import React from "react";
import PropTypes from "prop-types";
import styles from "./BSMSectionElement.module.css";
import { IconPlay, IconView } from "@wwg/icons/dist/index";

/**
 * View component. Displays BSM item content for a feed item section.
 */
export function BSMSectionElement({ bsmItem }) {
  return (
    <div className={styles.container}>
      {bsmItem === undefined ||
      bsmItem === null ||
      (bsmItem && bsmItem.length) === 0 ? (
        <h4 className={styles.text}> No BSM Items Selected</h4>
      ) : (
        <>
          {bsmItem.map((item, index) => (
            <div className={index !== bsmItem.length - 1 ? styles.bsmItem : styles.lastBsmItem} key={index}>
              <div className={styles.title}>{item.title}</div>
              <div className={styles.mediaSection}>
                <IconPlay />
              </div>
            </div>
          ))}
        </>
      )}
    </div>
  );
}

BSMSectionElement.propTypes = {
  /**
   * BSM item content.
   */
  bsmItem: PropTypes.string,
};
